// extracted by mini-css-extract-plugin
export default {"tag":"RoleTag_tag__lCFy2","label":"RoleTag_label__yT13v","close":"RoleTag_close__-G2ii"};